// src/components/CookiePreferencesButton.tsx
// The functional "Your Privacy Choices" control referenced by the footer link
// and the Privacy Policy. Clearing the stored choice re-shows the consent
// banner (and, if the visitor had accepted, stops analytics from loading on the
// next visit). GPC, when the browser sends it, always takes precedence in
// CookieConsent regardless of this stored value.

import React, { useState } from "react";
import { clearConsent } from "../lib/consent";

const CookiePreferencesButton: React.FC = () => {
  const [reset, setReset] = useState(false);

  const handleReset = () => {
    clearConsent();
    setReset(true);
    // Reload even though the banner and the gated embeds now react on their own:
    // a visitor who had accepted already has gtag on the page, and only a fresh
    // document actually unloads it. Revocation should take effect immediately.
    window.location.reload();
  };

  return (
    <span className="inline-flex items-center gap-2">
      <button
        type="button"
        onClick={handleReset}
        className="text-brown underline hover:text-brown-dark"
      >
        Manage cookie preferences
      </button>
      {reset && <span className="text-sm text-gray-500">Resetting…</span>}
    </span>
  );
};

export default CookiePreferencesButton;
